import React from 'react';
import { Box } from 'wix-style-react';
import { SourceButton } from '../../../PageElements/SourceButton';
import { StoreContext } from '../../../../appContext/StoreProvider';

export const MarkdownSourceLinkButton = ({ mdFileSrc }) => {
  const { store } = React.useContext(StoreContext);

  const shouldShowSourceLink =
    store.viewer.viewerConfig.displayOptions.showSourceLink && mdFileSrc;

  return shouldShowSourceLink ? (
    <Box align="right" paddingTop="1px">
      <SourceButton href={mdFileSrc} />
    </Box>
  ) : null;
};
